/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, {
  useCallback, useEffect, useState,
} from 'react';
import { useQueryParams, StringParam } from 'use-query-params';

import { Icon, RatesAndDatesTabs } from '@powdr/components';
import { QueryParamNames } from '@powdr/constants';
import { ColorProfiles } from '@powdr/web/constants/demos';

import {
  ActiveRDContainer, Selector, Selectors, StyledRatesAndDatesSwitcher,
} from './styles';

const ratesDatesParams = {
  [QueryParamNames.SWITCH]: StringParam,
};

export const RatesAndDatesSwitcher = ({
  className = '',
  parentColorProfile,
  relationships,
}) => {
  const colorProfile = parentColorProfile || ColorProfiles.BASE;
  const { tabs } = relationships;
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [urlQueryParams] = useQueryParams(ratesDatesParams);

  const selectionHandler = (idx) => {
    setActiveTabIndex(idx);
  };

  const getActiveTabFromParams = useCallback(
    () => tabs.findIndex((t) => t.tabTitle === urlQueryParams?.[QueryParamNames.SWITCH]),
    [tabs, urlQueryParams],
  );

  useEffect(() => {
    if (urlQueryParams?.[QueryParamNames.SWITCH]) {
      setActiveTabIndex(getActiveTabFromParams());
    }
  }, [urlQueryParams, getActiveTabFromParams]);

  return (
    <StyledRatesAndDatesSwitcher className={className}>
      {(tabs?.length > 1) && (
        <Selectors>
          {tabs.map((hotspotImage, idx) => (
            <li>
              <Selector
                key={hotspotImage.id}
                tabIndex="0"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => selectionHandler(idx)}
                $colorProfile={colorProfile}
                $active={idx === activeTabIndex}
              >
                {(idx === activeTabIndex) && <Icon className="selector-icon" name="ui-checkmark" height={20} width={20} />}
                {hotspotImage.tabTitle}
              </Selector>
            </li>
          ))}
        </Selectors>
      )}
      <ActiveRDContainer>
        <RatesAndDatesTabs
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...tabs[activeTabIndex]}
          activeParentTab={activeTabIndex}
          colorProfile={colorProfile}
        />
      </ActiveRDContainer>
    </StyledRatesAndDatesSwitcher>
  );
};

RatesAndDatesSwitcher.propTypes = {
  className: PropTypes.string,
  parentColorProfile: PropTypes.string,
  relationships: PropTypes.shape({
    tabs: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};
